/*
 * @Author: K
 * @Date: 2022-04-09 16:13:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-13 17:12:46
 * @FilePath: \app-pcweb\src\router\auth-guard.js
 */
import store from "@/lobby_common/store/index";
import Bus from "@/lobby_common/utils/bus.js";
export default (to, from, next) => {
  const res = store.getters.getPacketConfig;
  // 充值教程详情 不需要权限
  const whites = [
    "/chargeTutorialDetail",
    "/user/hTask",
    "/userCenter",
  ];
  if (whites.includes(to.path)) {
    return next();
  }
  // 试玩游戏跳转
  if (to.meta?.title === "route.payGame") {
    return next();
  }
  if (res?.code === 1050053) {
    if (to.path !== "/403") {
      next("/403");
    }
  }
  if (store.getters.taken) {
    next();
  } else {
    next("/home");
    Bus.$emit("showLogin");
  }
};
